import {
  Button,
  Dialog,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  LinearProgress,
  Snackbar,
  Alert,
  Slide,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  tableCellClasses,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Chip,
  Autocomplete,
  Divider,
  Switch,
  AccordionDetails,
  AccordionSummary,
  Accordion,
  Collapse,
  Tooltip,
  DialogContent,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import { Container } from 'reactstrap';
import moment from 'moment';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';
import NoResultsFound from '../../components/NoResultsFound';

const StyledTableCell = styled(TableCell)({
  color: 'white !important',
  border: 'solid 1px #dee2e6',
  fontWeight: '800',
  // textAlign: 'center',
  backgroundColor: '#47A992',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const AssignInspectionInitialValue = {
  Buyer: '',
  Factory: '',
  Style: '',
  Inspector: '',
  InspectionClassification: '',
};

const filterInitialValue = {
  FromDate: moment().startOf('month').format('YYYY-MM-DD'),
  ToDate: moment().format('YYYY-MM-DD'),
  Buyer: { BuyerId: null, Buyer: 'All Buyers' },
  Factory: { AccId: null, AccName: 'All Factories' },
  Style: { IpoNo: null, StyleNo: 'All Styles' },
  Inspector: { UserID: null, LoginName: 'All Inspectors' },
  InspectionClassification: {
    InspectionClassificationId: null,
    InspectionClassification: 'All Classifications',
  },
};

const AssignInspection = () => {
  const [filterData, setFilterData] = useState(filterInitialValue);
  const [AssignInspections, setAssignInspections] = useState([]);
  const [buyers, setBuyers] = useState([]);
  const [factories, setFactories] = useState([]);
  const [styles, setStyles] = useState([]);
  const [inspectionClassifications, setInspectionClassifications] = useState([]);
  const [filterStyles, setFilterStyles] = useState([]);
  const [users, setUsers] = useState([]);
  const [expanded, setExpanded] = useState(true);
  const [UserId, setUserId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);

  const [edit, setEdit] = useState(false);

  const [initialValue, setInitialValue] = useState(AssignInspectionInitialValue);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [open, setOpen] = useState(false);
  const [openUnAssign, setOpenUnAssign] = useState(false);
  const [remark, setRemark] = useState('');
  const [assignInspectionId, setAssignInspectionId] = useState(null);

  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // api fetch data
  useEffect(() => {
    const UserId = sessionStorage.getItem('UserId');
    setUserId(UserId);
    getAllAssignInspection();
    GetAllHelpData();
  }, []);

  const GetAllHelpData = async () => {
    try {
      showLoading();
      const resData = await axios.get('ReferenceData/GetAllBuyers');
      const resData1 = await axios.get('ReferenceData/GetAllFactories');
      const resData2 = await axios.get('Master/User/GetAllActiveUser');
      const resData3 = await axios.get('Master/InspectionClassification/GetAllInspectionClassification');

      setBuyers(resData.data);
      setFactories(resData1.data);
      setUsers(resData2.data);
      setInspectionClassifications(resData3.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  async function getAllAssignInspection() {
    try {
      showLoading();
      const response = await axios.post('Transaction/AssignInspection/GetAllAssignedInspection', {
        FromDate: moment(filterData.FromDate).format('YYYYMMDD'),
        ToDate: moment(filterData.ToDate).format('YYYYMMDD'),
        FactoryId: filterData.Factory.AccId,
        BuyerId: filterData.Buyer.BuyerId,
        StyleNo: filterData.Style.StyleNo === 'All Styles' ? null : filterData.Style.StyleNo,
        InspectionClassificationId: filterData.InspectionClassification.InspectionClassificationId,
        InspectorId: filterData.Inspector.UserID,
      });
      setAssignInspections(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function AddUpdateAssignInspection(values) {
    try {
      const { Buyer, Factory, Style, Inspector, InspectionClassification, ...RemaingValues } = values;
      showLoading();
      await axios.post(`Transaction/AssignInspection/${edit ? 'updateAssignedInspection' : 'AddAssignedInspection'}`, {
        ...RemaingValues,
        BuyerId: Buyer.BuyerId,
        FactoryId: Factory.AccId,
        StyleNo: Style.StyleNo,
        IpoNo: Style.IpoNo,
        InspectionClassificationId: InspectionClassification.InspectionClassificationId,
        InspectorId: Inspector.UserID,
        UserId,
      });
      getAllAssignInspection();
      openSnackBar(`Assign Inspection ${edit ? 'Updated' : 'Added'} Successfully!`, edit ? 'warning' : 'success');
      // setFilterData(filterInitialValue);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
    setOpen(false);
  }

  const DeleteAssignInspection = async () => {
    try {
      showLoading();
      await axios.delete(`Transaction/AssignInspection/DeleteAssignedInspection/${deleteId}`);
      const newDefectCategory = AssignInspections.filter((inspection) => inspection.AssignID !== deleteId);
      setAssignInspections(newDefectCategory);
      openSnackBar('Assign Inspection Deleted Successfully!', 'warning');
      // setFilterData(filterInitialValue);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    handleCloseDelete();
    setDeleteId(null);
    hideLoading();
  };

  const getAllStyleNo = async (BuyerId, FactoryId) => {
    try {
      if (!BuyerId || !FactoryId) return;
      const response = await axios.post('ReferenceData/GetAllStyles', { BuyerId, FactoryId, Inspection: 'N' });
      setStyles(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
  };

  const getAllFilterStyleNo = async () => {
    try {
      if (!filterData.Factory.AccId || !filterData.Buyer.BuyerId) return;
      const response = await axios.post('Transaction/AssignInspection/GetStyleNo', {
        FromDate: moment(filterData.FromDate).format('YYYYMMDD'),
        ToDate: moment(filterData.ToDate).format('YYYYMMDD'),
        FactoryId: filterData.Factory.AccId,
        BuyerId: filterData.Buyer.BuyerId,
      });
      setFilterData({ ...filterData, Style: { Text: null, StyleNo: 'All Styles' } });
      setFilterStyles(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    // hideLoading();
  };

  const handleFilterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };

  const handleCloseDialog = () => {
    setOpen(!open);
    setStyles([]);
    setInitialValue(AssignInspectionInitialValue);
  };

  useEffect(() => {
    getAllFilterStyleNo();
  }, [filterData.Buyer, filterData.Factory, filterData.FromDate, filterData.ToDate]);

  const filteredData = useMemo(() => {
    const newTableData = [...AssignInspections];
    if (page > 0) setPage(0);
    return newTableData;
  }, [AssignInspections, filterData]);

  // pagination
  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = filteredData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [filteredData, page, rowsPerPage]);

  const AssignInspectionValidationSchema = useMemo(
    () =>
      Yup.object().shape({
        Buyer: Yup.object().required('Please select Buyer'),
        Factory: Yup.object().required('Please select Factory'),
        Style: Yup.object().required('Please select Style'),
        Inspector: Yup.object().required('Please select Inspector'),
        InspectionClassification: Yup.object().required('Please select Inspection Classification'),
      }),
    []
  );

  const handleOpen = (assignId) => {
    setOpenUnAssign(true);
    setAssignInspectionId(assignId);
  };
  const handleClose = () => {
    setRemark('');
    setOpenUnAssign(false);
    setAssignInspectionId(null);
  };

  const handleConfirm = () => {
    if (remark.trim()) {
      UnAssignInspection();
    } else {
      alert('Please enter a remark before unassigning.');
    }
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setDeleteId(null);
  };

  const handleEditClick = async (values) => {
    try {
      showLoading();
      const { BuyerId, Buyer, FactoryId, Factory, Inspector, InspectorId, StyleNo, ...RemaingValues } = values;
      if (!BuyerId || !FactoryId) return;
      const response = await axios.post('ReferenceData/GetAllStyles', { BuyerId, FactoryId });
      setStyles(response.data);
      const Style = response.data.find((style) => style.StyleNo === StyleNo);
      const NewValues = {
        Buyer: { BuyerId, Buyer },
        Factory: { AccId: FactoryId, AccName: Factory },
        Style,
        Inspector: { UserID: InspectorId, LoginName: Inspector },
        ...RemaingValues,
      };
      setInitialValue(NewValues);
      setOpen(true);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  const UnAssignInspection = async () => {
    try {
      showLoading();
      await axios.post(`Transaction/AssignInspection/UnAssignInspection`, {
        AssignId: assignInspectionId,
        Remark: remark,
        UserId
      });
      getAllAssignInspection();
      openSnackBar(`Inspection UnAssigned Successfully!`, 'success');
      handleClose();
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* table header */}
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#47A992',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              ASSIGN INSPECTION
            </Typography>
          </Typography>
        </Grid>
        <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
          <Accordion
            expanded={expanded}
            onChange={() => {
              setExpanded((expand) => !expand);
            }}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#8EACCD' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                <IconButton aria-label="ExpandMoreIcon" color="#8EACCD">
                  <FilterAltIcon style={{ color: '#8EACCD', width: 24, height: 24 }} />
                </IconButton>
                <Typography
                  sx={{
                    color: '#8EACCD',
                    '&.active': {
                      color: 'text.primary',
                      bgcolor: 'action.selected',
                      fontWeight: 'fontWeightBold',
                    },
                  }}
                  variant="h6"
                >
                  Filters
                </Typography>
              </Stack>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Grid container spacing={2} p={1} pt={0} mb={0.5} rowSpacing={2} columnSpacing={1}>
                <Grid item md={2} xs={12}>
                  {/* From Date */}
                  <TextField
                    fullWidth
                    label="From Date"
                    type="date"
                    name="fromDate"
                    value={filterData.FromDate}
                    onChange={(e) => {
                      handleFilterDataChange('FromDate', e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    inputProps={{ max: '9999-12-31' }}
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  {/* To Date */}
                  <TextField
                    fullWidth
                    label="To Date"
                    type="date"
                    name="ToDate"
                    value={filterData.ToDate}
                    onChange={(e) => {
                      handleFilterDataChange('ToDate', e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    // error={!!formErrors.toDate}
                    // helperText={formErrors.toDate}
                    inputProps={{ max: '9999-12-31' }}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    options={[{ AccId: null, AccName: 'All Factories' }, ...factories]}
                    getOptionLabel={(factory) => factory.AccName}
                    isOptionEqualToValue={(value) => value.AccId === filterData.Factory.AccId}
                    renderOption={(props, factory) => (
                      <li {...props} key={factory.AccId}>
                        {factory.AccName}
                      </li>
                    )}
                    value={filterData.Factory || null}
                    name="Factory"
                    onChange={(event, value) => {
                      handleFilterDataChange('Factory', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Factory" />}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <Autocomplete
                    options={[{ BuyerId: null, Buyer: 'All Buyers' }, ...buyers]}
                    getOptionLabel={(buyers) => buyers.Buyer}
                    isOptionEqualToValue={(value) => value.BuyerId === filterData.Buyer?.BuyerId}
                    renderOption={(props, buyers) => (
                      <li {...props} key={buyers.BuyerId}>
                        {buyers.Buyer}
                      </li>
                    )}
                    value={filterData.Buyer}
                    name="Buyer"
                    onChange={(event, value) => {
                      handleFilterDataChange('Buyer', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Buyer" />}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <Autocomplete
                    options={[{ IpoNo: null, StyleNo: 'All Styles' }, ...filterStyles]}
                    getOptionLabel={(styles) => styles.StyleNo}
                    isOptionEqualToValue={(value) => value.StyleNo === filterData.Style.StyleNo}
                    renderOption={(props, styles) => (
                      <li {...props} key={`${styles.StyleNo}`}>
                        {styles.StyleNo}
                      </li>
                    )}
                    value={filterData.Style || null}
                    name="Style"
                    onChange={(event, value) => {
                      handleFilterDataChange('Style', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Style No" />}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <Autocomplete
                    options={[{ UserID: null, LoginName: 'All Inspectors' }, ...users]}
                    getOptionLabel={(users) => users.LoginName}
                    isOptionEqualToValue={(value) => value.UserID === filterData.Inspector.UserID}
                    renderOption={(props, user) => (
                      <li {...props} key={user.UserID}>
                        {user.LoginName} {user.Designation ? ` ( ${user.Designation} )` : ''}
                      </li>
                    )}
                    value={filterData.Inspector || null}
                    name="Inspector"
                    onChange={(event, value) => {
                      handleFilterDataChange('Inspector', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Inspector" />}
                  />
                </Grid>{' '}
                <Grid item md={3} xs={12}>
                  <Autocomplete
                    options={[
                      { InspectionClassificationId: null, InspectionClassification: 'All Classifications' },
                      ...inspectionClassifications,
                    ]}
                    getOptionLabel={(item) => item.InspectionClassification}
                    isOptionEqualToValue={(value) =>
                      value.UserID === filterData.InspectionClassification.InspectionClassificationId
                    }
                    renderOption={(props, item) => (
                      <li {...props} key={item.InspectionClassificationId}>
                        {item.InspectionClassification}
                      </li>
                    )}
                    value={filterData.InspectionClassification || null}
                    name="InspectionClassification"
                    onChange={(event, value) => {
                      handleFilterDataChange('InspectionClassification', value);
                    }}
                    size="small"
                    disableClearable
                    renderInput={(params) => <TextField {...params} label="Inspection Classification" />}
                  />
                </Grid>
                <Grid item xs={3} sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      getAllAssignInspection();
                    }}
                    sx={{ boxShadow: 0 }}
                  >
                    View
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    sx={{ boxShadow: 1 }}
                    fullWidth
                    onClick={() => {
                      setOpen(!open);
                      setStyles([]);
                    }}
                    startIcon={<PlaylistAddIcon />}
                  >
                    Assign
                  </Button>
                  {/* View Button */}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Stack>
        <Collapse in={filteredData.length > 0}>
          <TableContainer sx={{ borderRadius: '7px', minHeight: '450px' }} component={Paper} elevation={2}>
            <Table className="table-bordered" size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">S.No</StyledTableCell>
                  <StyledTableCell align="left">Factory</StyledTableCell>
                  <StyledTableCell align="left">Buyer</StyledTableCell>
                  <StyledTableCell align="left">Inspection Classification</StyledTableCell>
                  <StyledTableCell align="left">Style No</StyledTableCell>
                  <StyledTableCell align="left">Inspector</StyledTableCell>
                  <StyledTableCell align="center">Assigned by</StyledTableCell>
                  <StyledTableCell align="center">Assigned On</StyledTableCell>
                  <StyledTableCell align="center">Actions</StyledTableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(rowsPerPage > 0
                  ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : filteredData
                ).map((AssignInspection, i) => (
                  <TableRow key={AssignInspection.AssignID} hover>
                    <TableCell align="center">{AssignInspection.SNo}</TableCell>
                    <TableCell align="left">{AssignInspection.Factory}</TableCell>
                    <TableCell align="left">{AssignInspection.Buyer}</TableCell>
                    <TableCell align="left">{AssignInspection.InspectionClassification}</TableCell>
                    <TableCell align="left">{`${AssignInspection.StyleNo}/${AssignInspection.IpoNo}`}</TableCell>
                    <TableCell align="left">{AssignInspection.Inspector}</TableCell>
                    <TableCell align="center">{AssignInspection.AssignedBy}</TableCell>
                    <TableCell align="center">{moment(AssignInspection.AssignedOn).format('DD/MM/YYYY')}</TableCell>

                    <TableCell align="center" sx={{ padding: '0' }}>
                      <Tooltip title="UnAssign" placement="top">
                        <IconButton aria-label="Edit" onClick={() => handleOpen(AssignInspection.AssignID)}>
                          <RemoveCircleOutlineIcon color="error" />
                        </IconButton>
                      </Tooltip>

                      {/* <IconButton
                        aria-label="Edit"
                        onClick={() => {
                          setEdit(true);
                          handleEditClick(AssignInspection);
                        }}
                      >
                        <EditIcon color="primary" />
                      </IconButton>
                      <IconButton
                        aria-label="Delete"
                        onClick={() => {
                          setDeleteId(AssignInspection.AssignID);
                          setOpenDelete(true);
                        }}
                      >
                        <DeleteForeverIcon color="error" />
                      </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}
                {/* {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )} */}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalRows}
            rowsPerPage={rowsPerPage}
            page={currentPage} // Use the calculated currentPage value
            onPageChange={(event, newPage) => setPage(newPage)}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0); // Reset the page when rowsPerPage changes
            }}
            mt={2}
          />
        </Collapse>
        {!filteredData.length > 0 && <NoResultsFound />}
        <Grid m={2}>
          {/* add new popup form dialog box */}
          <Dialog maxWidth={'sm'} open={open} onClose={handleCloseDialog} fullWidth>
            <Container component={Paper} elevation={2} style={{ padding: '7px 14px' }}>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h6" textAlign={'left'} pl={2} fontWeight={600} color="primary">
                  {edit ? 'Update' : ''} Assign Inspection
                </Typography>
                <IconButton onClick={handleCloseDialog}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack sx={{ p: 1 }}>
                <Formik
                  validationSchema={AssignInspectionValidationSchema}
                  initialValues={initialValue}
                  onSubmit={async (values, { resetForm }) => {
                    AddUpdateAssignInspection(values);
                    resetForm();
                  }}
                >
                  {({ submitForm, values, errors, touched, handleBlur, setFieldValue, isSubmitting }) => (
                    <Form>
                      <Grid container spacing={2} p={1} rowSpacing={3}>
                        <Grid item width={'100%'}>
                          <Autocomplete
                            options={inspectionClassifications}
                            getOptionLabel={(inspectionClass) => inspectionClass.InspectionClassification}
                            isOptionEqualToValue={(value) =>
                              value.InspectionClassificationId ===
                              values.InspectionClassification.InspectionClassificationId
                            }
                            renderOption={(props, inspectionClass) => (
                              <li {...props} key={inspectionClass.InspectionClassificationId}>
                                {inspectionClass.InspectionClassification}
                              </li>
                            )}
                            value={values.InspectionClassification || null}
                            name="InspectionClassification"
                            onChange={(event, value) => {
                              setFieldValue('InspectionClassification', value);
                            }}
                            size="small"
                            onBlur={handleBlur}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Inspection Classification"
                                error={touched.InspectionClassification && !!errors.InspectionClassification}
                                helperText={touched.InspectionClassification && errors.InspectionClassification}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <Autocomplete
                            options={factories}
                            getOptionLabel={(factory) => factory.AccName}
                            isOptionEqualToValue={(value) => value.AccId === values.Factory.AccId}
                            renderOption={(props, factory) => (
                              <li {...props} key={factory.AccId}>
                                {factory.AccName}
                              </li>
                            )}
                            value={values.Factory || null}
                            name="Factory"
                            onChange={(event, value) => {
                              setFieldValue('Factory', value);
                              setFieldValue('Style', '');
                              getAllStyleNo(values?.Buyer?.BuyerId, value?.AccId);
                            }}
                            size="small"
                            onBlur={handleBlur}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Factory"
                                error={touched.Factory && !!errors.Factory}
                                helperText={touched.Factory && errors.Factory}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <Autocomplete
                            options={buyers}
                            getOptionLabel={(buyers) => buyers.Buyer}
                            isOptionEqualToValue={(value) => value.BuyerId === values.Buyer.BuyerId}
                            renderOption={(props, buyers) => (
                              <li {...props} key={buyers.BuyerId}>
                                {buyers.Buyer}
                              </li>
                            )}
                            value={values.Buyer || null}
                            name="Buyer"
                            onChange={(event, value) => {
                              setFieldValue('Buyer', value);
                              setFieldValue('Style', '');
                              getAllStyleNo(value?.BuyerId, values?.Factory?.AccId);
                            }}
                            size="small"
                            onBlur={handleBlur}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Buyer"
                                error={touched.Buyer && !!errors.Buyer}
                                helperText={touched.Buyer && errors.Buyer}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <Autocomplete
                            options={styles}
                            getOptionLabel={(styles) => styles.TEXT}
                            isOptionEqualToValue={(value) => value.TEXT === values.Style.TEXT}
                            renderOption={(props, styles) => (
                              <li {...props} key={styles.TEXT}>
                                {styles.TEXT}
                              </li>
                            )}
                            value={values.Style || null}
                            name="Style"
                            onChange={(event, value) => {
                              setFieldValue('Style', value);
                            }}
                            size="small"
                            onBlur={handleBlur}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Style No"
                                error={touched.Style && !!errors.Style}
                                helperText={touched.Style && errors.Style}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <Autocomplete
                            options={users}
                            getOptionLabel={(users) => users.LoginName}
                            isOptionEqualToValue={(value) => value.UserId === values.Inspector.UserId}
                            renderOption={(props, user) => (
                              <li {...props} key={user.UserId}>
                                {user.LoginName} {user.Designation ? ` ( ${user.Designation} )` : ''}
                              </li>
                            )}
                            value={values.Inspector || null}
                            name="Inspector"
                            onChange={(event, value) => {
                              setFieldValue('Inspector', value);
                            }}
                            size="small"
                            onBlur={handleBlur}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Inspector"
                                error={touched.Inspector && !!errors.Inspector}
                                helperText={touched.Inspector && errors.Inspector}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>

                      <Stack direction="row" justifyContent="center" gap={2} sx={{ textAlign: 'center', mt: 3 }}>
                        <Button
                          onClick={submitForm}
                          disabled={isSubmitting}
                          fullWidth
                          variant="contained"
                          color={edit ? 'warning' : 'primary'}
                          size="small"
                          sx={{ boxShadow: 1 }}
                        >
                          {edit ? 'Update' : ''} Assign Inspection
                        </Button>
                      </Stack>
                    </Form>
                  )}
                </Formik>
              </Stack>
            </Container>
          </Dialog>
        </Grid>
      </Container>
      {/* confirmation dialog */}
      <Dialog open={openUnAssign} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Unassign Inspection</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Remark"
            fullWidth
            multiline
            minRows={3}
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} size="small" variant="contained" color="warning">
            Cancel
          </Button>
          <Button onClick={handleConfirm} size="small" color="error" variant="contained">
            Unassign
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openDelete} onClose={handleCloseDelete} fullScreen={fullScreen} fullWidth maxWidth="xs">
        <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
        <DialogActions>
          <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
            Cancel
          </Button>
          <Button variant="contained" onClick={DeleteAssignInspection} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AssignInspection;
